
import { useTransactionsManager } from './transactions/useTransactionsManager';

export function useTransactions(limit = 100, initialStatus?: string) {
  return useTransactionsManager({ limit, initialStatus });
}
